import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {ActivityIndicator, Platform, ScrollView} from "react-native";
import {isFullSwing, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from "../constants";
import FSHeader from "../components/FSHeader";
import Div from "../lib/Div";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import P from "../lib/P";
import NewHeader from "../components/NewHeader";
import {StoreContext} from "../components/StoreContextProvider";
import useIdleLogout from "../hooks/useIdleLogout";
import {colors} from "../assets/styles/colors";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {RouteProp, useIsFocused, useNavigation, useRoute} from "@react-navigation/native";
import ServiceClient from "../utils/ServiceClient";
import {CancelModalProps} from "../types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import moment from "moment";
import {LevelTournamentList, Tournament, TournamentPrizeDistributionItem, TournamentPrizeDistributionItem_AwardKind, User} from "../../generated/smg_service_pb";
import Btn from "../components/Btn";
import {formatCurrency} from "../utils";
import ContinueAutoPlayModal from "../modals/ContinueAutoPlay";
import TournamentCard from "../components/TournamentCard";
import JoinTournamentButton from "../components/JoinTournamentButton";

const AwardKind = TournamentPrizeDistributionItem_AwardKind;

const LevelSatellitesScreen = () => {
  const Context = useContext(StoreContext);
  const {user, cancelModalConfig, session, extendedUserData} = Context;
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const route = useRoute<RouteProp<{ params?: { level: string } }, 'params'>>();
  const currentLevel = route.params?.level || 0;
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(false);
  const [levelTournament, setLevelTournament] = useState<LevelTournamentList>();
  const [tournament, setTournament] = useState<Tournament>();
  const [continueAutoPlay, setContinueAutoPlay] = useState(false);
  const [tournamentId, setTournamentId] = useState<number>();
  const [prizeDistribution, setPrizeDistribution] = useState<TournamentPrizeDistributionItem[]>();

  const getTournamentPrizeDistribution = (id?: number) => {
    ServiceClient.getTournamentPrizeDistribution(id).then(res => {
      setPrizeDistribution(res?.items);

    }).catch(err => {
      console.log('getTournamentPrizeDistribution err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    })
  };

  const getTournament = (id?: number) => {
    if (id) setTournamentId(id);
    if (!tournament) Context.setLoadingOverlay(true);

    ServiceClient.getTournament(id || tournamentId).then(res => {
      Context.setLoadingOverlay(false);
      setTournament(res);
      if (extendedUserData.hasActiveTournament && extendedUserData.tournamentAutoPlayAmount === -3) setContinueAutoPlay(true);
      getTournamentPrizeDistribution(res?.id);

    }).catch(err => {
      console.log('getTournament err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const goBack = () => {
    if (!!tournament) setTournament(undefined);
    else if (navigation.canGoBack()) navigation.goBack();
    else navigation.navigate('TournamentSeries');
  };

  const getTournamentSchedule = () => {
    ServiceClient.getTournamentSchedule().then(res => {
      setLevelTournament(res.find(el => el.level === +currentLevel));
      Context.setLoadingOverlay(false);
      setIsLoading(false);
      if (!!tournament) getTournament();

    }).catch(err => {
      console.log('getTournamentSchedule err', err);
      Context.setLoadingOverlay(false);
      setIsLoading(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const getUser = () => {
    Context.getUser().catch(err => {
      console.log('getUser err', err);
      setTimeout(() => {
        getUser();
      }, 5000);
    });
  };

  useEffect(() => {
    if (!user || !isFocused) return;

    getTournamentSchedule();

    const time = setTimeout(() => {
      getUser();
    }, 1000 * 10);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused]);

  useIdleLogout({enabled: isFocused, onLogout: () => setIsLoading(false)});

  useLayoutEffect(() => {
    setIsLoading(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            });

          } else console.log('user', curUser);
        }
      })();
    }
  }, []);

  return (
    <>
      {isFullSwing ? (
        <>
          <FSHeader px={20}/>

          <Div h={2} bg="#252526"/>

          <Div gap={5} py={10} px={20}>
            <Div row alignItems="center">
              <Div w={24} alignItems="center"><FontAwesome name="user-circle" size={24} color="#3399FF"/></Div>
              <P fontFamily="DavisSans-Regular" ml={6}>{user?.username}</P>
            </Div>
          </Div>

          <Div h={2} bg="#252526"/>
        </>
      ) : <NewHeader pb={11}/>}

      <Div flex={1}>
        <ScrollView>
          <Div row justifyContent="space-between" alignItems={isFullSwing ? 'flex-start' : 'flex-end'}
               mb={isFullSwing ? 30 : 48} pt={isFullSwing ? 13 : 0}>
            <Div>
              {(isFullSwing && !tournament) && (
                <P fontFamily="DavisSans-Medium" fs={20} ml={18} color="#737373" lh={24}>Tournament Series</P>
              )}
              <P fontFamily={isFullSwing ? 'DavisSans-Medium' : 'Barlow-Medium'} fs={isFullSwing ? 20 : 30}
                 ml={isFullSwing ? 18 : 21} lh={isFullSwing ? undefined : 24}>
                {!!tournament ? 'Tournaments' : '/ Level Satellites'}
              </P>
            </Div>

            <P color={isFullSwing ? '#0AF' : colors.newGreenText} tt="uppercase" fs={isFullSwing ? 14 : 12}
               fontFamily={isFullSwing ? 'DavisSans-Medium' : 'Barlow-Bold'} mr={isFullSwing ? 18 : 5}
               ta={isFullSwing ? 'right' : undefined} onPress={goBack} lh={isFullSwing ? 24 : undefined}>
              {!!tournament ? '< Level Satellites' : '< SEE ALL SERIES'}
            </P>
          </Div>

          {isLoading ? (
            <Div flex={1} justifyContent="center" alignItems="center">
              <ActivityIndicator color={colors.white} size="large"/>
            </Div>
          ) : !!tournament ? (
            <TournamentCard
              tournament={tournament} getUser={getUser} getTournament={getTournament} level={currentLevel}
              goBack={goBack} prizeDistribution={prizeDistribution}
            />
          ) : currentLevel && !!levelTournament ? (
            <>
              <P fontFamily="DavisSans-Medium" fs={32} ml={11} lh={42} mb={14}>Level {currentLevel}</P>

              {levelTournament.tournaments.length ? (
                <Div rounded={2} borderWidth={1} mx="auto" borderColor="#4C4C4C" bg="#252526" maxH={305} w={338} pt={9}
                     px={13}>
                  <Div row borderBottomWidth={1} borderColor="#484848" mb={7}>
                    <Div flex={1}>
                      <P ta="center" color="#CDCDCD" fontFamily="DavisSans-Medium" fs={10} lh={24}>DATE / TIME</P>
                    </Div>
                    <Div flex={1} row>
                      <P ta="center" color="#CDCDCD" fontFamily="DavisSans-Medium" fs={10} lh={24} flex={1}>ENTRY</P>
                      <P ta="center" color="#CDCDCD" fontFamily="DavisSans-Medium" fs={10} lh={24} flex={1}>
                        1st Prize
                      </P>
                    </Div>
                  </Div>

                  <ScrollView>
                    {levelTournament.tournaments.map(el => {
                      const isExpired = moment.unix(Number(el.entryEndDate)).isBefore();
                      // const isCompleted = el.state === TournamentState.FINISHED || el.state === TournamentState.CANCELLED || el.state === TournamentState.VOIDED;
                      const textColor = isExpired ? 'gray' : '#35A4FF';
                      // #3369FF

                      return (
                        <Btn key={el.id} row onPress={() => getTournament(el.id)} mb={4}>
                          <Div flex={1} row justifyContent="space-between">
                            <Div w={26} h={26} rounded={26} bg="#3369FF" justifyContent="center" alignItems="center">
                              <P ta="center" fontFamily="DavisSans-Medium" fs={13}>L{currentLevel}</P>
                            </Div>

                            <P fontFamily="DavisSans-Medium" fs={12} lh={26} color={textColor}>
                              {moment.unix(Number(el.entryBeginDate)).format('ddd, MMM DD')} / {moment.unix(Number(el.entryBeginDate)).format('hh:mm A')}
                            </P>
                          </Div>

                          <Div flex={1} row>
                            <P fontFamily="DavisSans-Medium" fs={12} ta="center" lh={26} flex={1} color={textColor}>
                              {formatCurrency(el.entryFee / 100)}
                            </P>
                            <P fontFamily="DavisSans-Medium" fs={12} ta="center" lh={26} flex={1} color={textColor}>
                              {el.firstPlaceAward?.kind === AwardKind.TICKET ? 'Ticket' : el.firstPlaceAward?.kind === AwardKind.PHYSICAL_PRIZE ? 'FS Kit' : el.firstPlaceAward?.kind === AwardKind.STATIC ? formatCurrency(el.firstPlaceAward.staticAwardPrize / 100) : formatCurrency((el.firstPlaceAward?.calculatedAwardPrize || 0) / 100)}
                            </P>
                          </Div>
                        </Btn>
                      )
                    })}
                  </ScrollView>
                </Div>
              ) : (
                <Div flex={1} justifyContent="center" alignItems="center">
                  <P fw="500" fs={32} mb={14} ml={21}>Nothing found</P>
                </Div>
              )}
            </>
          ) : (
            <Div flex={1} justifyContent="center" alignItems="center">
              <P fw="500" fs={32} mb={14} ml={21}>Nothing found</P>
            </Div>
          )}
        </ScrollView>
      </Div>

      {!!tournament && (
        <JoinTournamentButton
          tournament={tournament || {}} onReload={getTournament} hideLeaveButton isTournamentSeries
        />
      )}

      <Btn w={341} my={isFullSwing ? 0 : 18} mx="auto" onPress={goBack}>
        <P fontFamily="DavisSans-Medium" ta="center" lh={isFullSwing ? 38 : 56} fs={21} color="#0AF">{'< Back'}</P>
      </Btn>

      <P color={colors.gray} ta="center" fs={17} my={13}>Malfunction voids all pays and plays</P>

      <ContinueAutoPlayModal isOpen={continueAutoPlay} onClose={() => setContinueAutoPlay(false)} onReload={getUser}/>
    </>
  );
};

export default LevelSatellitesScreen;
